import { Injectable } from '@angular/core';

import * as _ from 'lodash';
import { Observable } from 'rxjs/Observable';
import { Subscriber } from 'rxjs/Subscriber';
export { Subscription } from 'rxjs/Subscription';

@Injectable()
export class SubMenuService {
    private onSubMenuChangedSubscribers: Subscriber<SubMenu>[] = [];

    constructor() {
        this.onSubMenuChanged = new Observable<SubMenu>((subscriber: Subscriber<SubMenu>) => {
            this.onSubMenuChangedSubscribers.push(subscriber);
        });
	}

	setSubMenu(menu: SubMenu) {

		// only refresh if there are any differences
		if (JSON.stringify(menu) !== JSON.stringify(this.menu)) {
			this.menu = menu;
		
		}

		this.notifySubscribers();

	}

	clear() {
		console.log("clear");
        this.menu = null;
        this.notifySubscribers();
    }

    private notifySubscribers() {
        for (let i = 0; i < this.onSubMenuChangedSubscribers.length;) {
            let subscriber = this.onSubMenuChangedSubscribers[i];
            if (subscriber.closed) {
                this.onSubMenuChangedSubscribers.splice(i, 1);
            } else {
                i++;
                subscriber.next(this.menu);
            }
        }
    }

    onSubMenuChanged: Observable<SubMenu>;
    menu: SubMenu;
}


export class SubMenu {
	constructor(public items: SubMenuItem[]) { }

	public get children() {
		return this.items;
	}

	isVisible = true;
}

export class SubMenuItem {

	private constructor(public text: string, public url: { url: string[], fragment?: string }, public items: SubMenuItem[] = [], public id: string = null, public label: string = null) { }

	public static createBranch(text: string, items: SubMenuItem[], id: string, label?: string) {
		return new SubMenuItem(text, null, items, id, label);
	}

	public static createLeaf(text: string, url: { url: string[], fragment?: string }, label?: string) {
		return new SubMenuItem(text, url, [], null, label);
	}

	get hasChildren() {
		return (this.items && this.items.length);
	}

	get children() {
		return this.items;
	}

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/core/menu/sub-menu.service.ts